import { FC } from "react";
import Button from "@lhd/components/Button";
import { ModalWrapper } from "./styled";

interface ModalEditConfirmProps {
  isOpen: boolean;
  content: string;
  onConfirm: () => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  width?: number;
}

const ModalEditConfirm: FC<ModalEditConfirmProps> = ({
  isOpen,
  content,
  onConfirm,
  onCancel,
  isSubmitting = false,
  width = 400,
}) => {
  return (
    <ModalWrapper
      width={width}
      open={isOpen}
      footer={
        <>
          <Button
            label="はい（更新する）"
            loading={isSubmitting}
            onClick={onConfirm}
          />
          <Button
            className="button-cancel"
            label="いいえ（更新しない）"
            onClick={onCancel}
            disabled={isSubmitting}
          />
        </>
      }
      onCancel={onCancel}
    >
      <p>{content}</p>
    </ModalWrapper>
  );
};

export default ModalEditConfirm;
